<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Edit Notification Pushover</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="label"
                autofocus
                autocomplete="off"
            />

            <v-text-field
                label="User Key"
                v-model="user_key"
                autocomplete="off"
            />

            <v-select
                label="Mode"
                v-model="mode"
                :items="$rc.enumChoices('employee_notification_mode', false)"
            />

            <v-alert
                v-model="alert_visible" 
                type="error" 
                dismissible
                color="primary"
            >
                {{alert_text}}
            </v-alert>

        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                @click="onClickTest"
                :disabled="!is_valid"
            >
                Send Test Notification
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const Validation = require('@/js/validate.js');
export default {

    data() {
        return {
            dialog: false,
            label: null,
            user_key: null,
            mode: 'notify-outside-of-dnd',
            index: -1,
            alert_visible: false,
            alert_text: null,
        }
    },

    methods: {

        showDialog(device)
        {
            if ( device == null )
            {
                device = {
                    'index': -1,
                    'user_key': null,
                    'label': null,
                    'mode': 'notify-outside-of-dnd',
                };
            }

            this.index = device.index;
            this.user_key = device.user_key;
            this.label = device.label;
            this.mode = device.mode;
            this.alert_visible = false;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            let device = {
                'index': this.index,
                'user_key': this.user_key,
                'label' : this.label.trim(),
                'mode' : this.mode,
            };

           this.$emit('ok', device);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickTest()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/employee-notifications/test-pushover',
            
                'params' : {
                        'user_key': this.user_key,
                        'employee_id': this.$route.params.employee_id,
                    },
            
                'on_success': (data) => {

                        if ( data.pushover_status == 'failed' )
                        {
                            this.alert_visible = true;
                            this.alert_text = 'Unable to send notification via pushover.  Check that your User Key is correct.';
                            return;
                        }

                        this.$rc.snackbar('Notification sent');
                    },
            
                'on_error': 'Unable to send test alert',
            });
        },

    },

    computed: {
        is_valid() {
            if ( this.label == null || this.label.trim().length == 0 ) return false;
            if ( this.user_key == null ) return false;
            if ( this.mode == null ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>